module.exports = __webpack_public_path__ + "static/timeline2005-2-f6f73f4e9d05ed590ff42dc8f6c0a2f0.jpeg";